import React, { useEffect, useState } from "react";
import Alert from "components/common/Alert";
import Loading from "components/common/Loading";
import { StripeElements } from "components/common/PurchaseModal/StripeElements";
import { StripeCheckoutForm } from "./StripeCheckoutForm";
import { usePreCheckoutWithStripe } from "./queries";
import styles from "./CheckoutModal.module.css";

interface Props {
  value: number;
  productId?: string;
  productVariationId?: string | null;
  couponCode?: string | null;
}

export const StripeCheckout = ({ value, productId, productVariationId, couponCode }: Props) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [clientSecretRequested, setClientSecretRequested] = useState(false);
  const [storedValue, setStoredValue] = useState(0);
  const getPreCheckout = usePreCheckoutWithStripe();

  useEffect(() => {
    const getSecret = async () => {
      const result = await getPreCheckout(productId, productVariationId, couponCode);
      setStoredValue(value);
      setClientSecret(result?.data?.preCheckoutWithStripe?.clientSecret || "_none");
    };

    if (!clientSecretRequested || (storedValue && value !== storedValue)) {
      setClientSecretRequested(true);
      getSecret();
    }
  }, [
    clientSecretRequested,
    value,
    couponCode,
    getPreCheckout,
    productId,
    productVariationId,
    storedValue,
  ]);

  if (!clientSecret) {
    return <Loading />;
  }

  if (clientSecret === "_none") {
    return <Alert theme="danger">Failed to load</Alert>;
  }

  return (
    <div className={styles.container}>
      {clientSecret && (
        <StripeElements clientSecret={clientSecret}>
          <StripeCheckoutForm value={storedValue} />
        </StripeElements>
      )}
    </div>
  );
};
